var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-left" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("TicketContactUser", {
            on: { change: _vm.onContactUserChange },
            model: {
              value: _vm.ticketEntity,
              callback: function($$v) {
                _vm.ticketEntity = $$v
              },
              expression: "ticketEntity"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        [
          _c(
            "span",
            {
              staticClass: "strong",
              attrs: { title: "在框中输入名字可搜索并修改" }
            },
            [_vm._v("处理人")]
          ),
          _vm._v(" "),
          _c("AssignToWorkflowDialog", { on: { change: _vm.onWorkflowChange } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        [
          _c("DealUserSearch", {
            ref: "assignUser_2",
            attrs: { css: "width:100%", userId: _vm.ticketEntity.dealUserId },
            on: { change: _vm.updateAssignUserId_2 }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "p",
        [
          _c("TicketStatusSelect", {
            on: { change: _vm.ticketStatusChange },
            model: {
              value: _vm.ticketEntity.orderStatus,
              callback: function($$v) {
                _vm.$set(_vm.ticketEntity, "orderStatus", $$v)
              },
              expression: "ticketEntity.orderStatus"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c(
        "p",
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "请选择优先级" },
              on: { change: _vm.ticketPriorityChange },
              model: {
                value: _vm.ticketEntity.orderPriority,
                callback: function($$v) {
                  _vm.$set(_vm.ticketEntity, "orderPriority", $$v)
                },
                expression: "ticketEntity.orderPriority"
              }
            },
            _vm._l(_vm.ticketPriorityList, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.name, value: item.value }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c(
        "p",
        [
          _c("TicketTypeCascader", {
            ref: "ticketType",
            attrs: { css: "width:100%" },
            on: { change: _vm.ticketTypeChange },
            model: {
              value: _vm.ticketEntity.orderType,
              callback: function($$v) {
                _vm.$set(_vm.ticketEntity, "orderType", $$v)
              },
              expression: "ticketEntity.orderType"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        [
          _c(
            "el-popover",
            { attrs: { width: "450", placement: "right", trigger: "hover" } },
            [
              _vm.ticketCcList && _vm.ticketCcList.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.ticketCcList, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticStyle: {
                            "font-weight": "900",
                            display: "inline-block",
                            width: "200px",
                            "line-height": "30px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(item.name) +
                              "(" +
                              _vm._s(item.loginName) +
                              ")"
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.ticketCcList || _vm.ticketCcList.length < 1
                ? _c("div", [
                    _c("span", { staticStyle: { "line-height": "30px" } }, [
                      _vm._v("输入名字或账号,把工单抄送给他")
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.ticketCcList || _vm.ticketCcList.length < 1
                ? _c(
                    "span",
                    { attrs: { slot: "reference" }, slot: "reference" },
                    [
                      _c("b", { staticClass: "strong" }, [_vm._v("抄送")]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "10px" } }, [
                        _vm._v("?")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.ticketCcList && _vm.ticketCcList.length > 0
                ? _c(
                    "span",
                    { attrs: { slot: "reference" }, slot: "reference" },
                    [
                      _c("b", { staticClass: "strong" }, [_vm._v("抄送")]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "10px" } }, [
                        _vm._v(
                          _vm._s(_vm.ticketCcList[0].name) +
                            "(" +
                            _vm._s(_vm.ticketCcList[0].loginName) +
                            ") 等 " +
                            _vm._s(_vm.ticketCcList.length) +
                            " 人"
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        [
          _c("NoticeUserSearch", {
            ref: "ticketCc",
            attrs: { css: "width:100%" },
            on: { change: _vm.onTicketCcChange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _c(
        "p",
        [
          _c("TicketTag", {
            attrs: { ticketNo: _vm.ticketEntity.orderId },
            on: { change: _vm.onTicketTagChange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("TicketWidgetGroup", {
        staticStyle: { width: "100%" },
        attrs: { group: "AfterTicketDetailLeft" }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("span", { staticClass: "strong" }, [_vm._v("联系人")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { attrs: { title: "可以选择并修改" } }, [
      _c("span", { staticClass: "strong" }, [_vm._v("状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { attrs: { title: "可以选择并修改" } }, [
      _c("span", { staticClass: "strong" }, [_vm._v("优先级")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { attrs: { title: "可以选择并修改" } }, [
      _c("span", { staticClass: "strong" }, [_vm._v("类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("span", { staticClass: "strong" }, [_vm._v("标签")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-460670f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-460670f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketDetailLeft.vue
// module id = 732
// module chunks = 75